<template>
  <v-app>
    <v-toolbar color="primary" fixed dark app><v-toolbar-title class="ms-0 ps-3"> {{ $t("app.name") }} </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">
                  {{ $t("auth.resetPassword") }}
                </div>
              </div>
            </v-card-title>
            <v-form ref="form" v-model="form" class="pa-4 pt-6">
              <v-text-field outline v-model="model.username" :rules="[rules.email]" :label='$t("auth.emailAddress")' type="email"
                @keyup.enter="resetPassword"></v-text-field>
              <v-text-field outline v-model="model.verification_code" :rules="[rules.required]" :label='$t("auth.verificationCode")' type="text"
                @keyup.enter="resetPassword"></v-text-field>
              <v-text-field outline v-model="model.password" :rules="[rules.password]" :label='$t("auth.password")'
                style="min-height: 96px" type="password" dense @keyup.enter="login"></v-text-field>
              <v-text-field outline v-model="model.confirm_password" :rules="[rules.required, confirm_password]"
                :label='$t("auth.confirmPassword")' style="min-height: 96px" type="password" dense
                @keyup.enter="login"></v-text-field>


              <v-btn @click="resetPassword" :loading="loading" block color="secondary" dark>{{ $t("auth.resetPassword") }}</v-btn>
            </v-form>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>


export default {
  title: "auth.resetPassword",
  data: () => ({
    loading: false,
    error: false,
    model: {
      username: "",
      verification_code:"",
      password: "",
      confirm_password: ""
    },
    socket: null,
    dialog: false,
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("auth.invalidEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("auth.invalidLength", { len }),
        password: (v) =>
          !!(v || "").match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë])[A-Za-z\d!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë]{8,15}$/) || this.$t("auth.passwordRule"),
        required: (v) => !!v || this.$t("auth.fieldRequired"),
      };
    },
  },
  created() {
    // QA V4 W3 (#23): prefill the email carried over from the request page
    // (ResetPasswordEmail.vue) so the user only enters the code + new password.
    const email = this.$route.query.email;
    if (email) {
      this.model.username = email;
    }
  },
  // mounted() {
  //   this.axios
  //     .get(this.api.ACTIONS.GET_LOGIN_IDENTFIER)
  //     .then(({ data: { data: qrCode } }) => {
  //       QRCode.toDataURL(qrCode, {
  //         errorCorrection: "high",
  //         version: 4,
  //       }).then((data) => {
  //         this.qrCode = data;
  //         this.socket = io(this.api.SOCKET.GUESTS, {
  //           transportOptions: {
  //             polling: {
  //               extraHeaders: {
  //                 authorization: qrCode,
  //               },
  //             },
  //           },
  //         });
  //         this.socket.on("authenticate", async (token) => {
  //           await this.$store.dispatch("validateToken", token);
  //           // const user = this.$store.state.user;
  //           let next = this.$route.query.next || "/dashboard";
  //           // if (this.airportAgency(user.roles))
  //           //     next = 'airport/create';
  //           window.getApp.$emit("APP_LOGIN_SUCCESS");
  //           await this.$router.push(next);
  //         });
  //       });
  //     });
  // },
  methods: {
    confirm_password(value) {
      console.log(this.model)
      return value === this.model.password || this.$t("auth.passwordsDontMatch")
    },
    async resetPassword() {
      if (!this.$refs.form.validate())
        return;
      this.error = false;
      this.loading = true;
      console.log(this.model);
      this.axios
        .post(this.api.ACTIONS.RESET_PASSWORD, { ...this.model, provider: "users" })
        .then(({ data }) => {

          window.getApp.$emit("RESET_PASSWORD_DONE");
          this.$router.push('/');
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("auth.checkInfo"), "red");
          }
        })
        .then(() => (this.loading = false));
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  content: "";
  z-index: 0;
}
</style>
